((definition) => {
  if (typeof define === "function" && define.amd) {
    define([
      "./canvas/canvas-service",
      "./mode/edit/canvas-edit-mode-service",
      "./mode/execution/canvas-execution-mode-service",
      "@client/template/select-dialog/template-select-dialog",
      "./detail-dialog/pipeline-detail-dialog-ctrl",
      "../../component/detail-dialog/instance-detail-dialog",
      "../import/pipeline-import-dialog-ctrl",
      "./template-detail-dialog/template-detail-dialog",
      "./pipeline-edit-dialog-service",
      "../../execution/log-tail/execution-log-tail-dialog",
      "../pipeline-api",
      "./pipeline-actions",
      "./canvas/pipeline-loader",
      "../../execution/execution-api",
      "@client/execution/execution-status-to-icon",
      "file-saver",
    ], definition);
  }
})((_canvasService, _editModeService, _executionModeService,
    _templateSelectDialog, _pipelineDetailDialog, _componentDetailDialog,
    _pipelineImportDialog, _templateDialog, _dialogService, _logTailDialog,
    pipelines, actions, loader, executions, statusToIcon, saveAs) => {
  "use strict";

  function factory(
    $location, $http, $mdDialog, $mdMedia,
    $pageLayout, $templates, $status, $refresh,
    $canvas, $editMode, $executionMode, $dialogs) {

    let $scope;
    let data = {
      "pipelineIri": undefined,
      "executionIri": undefined,
      "executionUpdate": false
    };

    let actionsCallbacks = {
      "onStartExecution": (iri) => {
        // Called when new execution is started.
        activateExecutionMode();
        data.executionIri = iri;
        loadExecution();
      }
    };

    function initialize(scope, pipeline, execution) {
      $scope = scope;
      $scope.canvasApi = {};
      $scope.isEditMode = true;
      $scope.pipelineLabel = "";
      $scope.isExecutionFinished = false;
      $scope.executionIcon = {
        "name": "",
        "style": {}
      };
      $scope.isExecutionCancelable = false;
      $scope.logsUrl = "./api/v1/executions-logs?iri=" + encodeURIComponent(execution);
      $scope.hasExecution = (execution ?? "").length > 0;
      $scope.activeVisual = "default";
      //
      data["pipelineIri"] = pipeline;
      data["executionIri"] = execution;
      //
      actions.updateVisual($scope.activeVisual);
    }

    function onHtmlReady() {
      actions.bind(
        $canvas, $templates, $dialogs, $status, $http, $location,
        actionsCallbacks);
      $canvas.bindUserApi(actions);
      $editMode.bind($canvas, actions);
      $executionMode.bind($canvas, actions);
      if (data["executionIri"]) {
        activateExecutionMode();
      } else {
        activateEditMode();
      }
      loadDataForFirstTime();
    }

    function activateEditMode() {
      $scope.isEditMode = true;
      $canvas.setInteractive(true);
      //
      $editMode.setEnabled(true);
      $executionMode.setEnabled(false);
      //
      $pageLayout.color = "#2196F3";
    }

    function activateExecutionMode() {
      $scope.isEditMode = false;
      $canvas.setInteractive(false);
      //
      $editMode.setEnabled(false);
      $executionMode.setEnabled(true);
      //
      $pageLayout.color = "#FF9800";
    }

    function loadDataForFirstTime() {
      console.time("Loading pipeline");
      $templates.load()
        .then(() => pipelines.loadLocal($http, data.pipelineIri))
        .then((jsonld) => {
          const pipeline = actions.pipelineFromJsonLd(jsonld);
          updatePipelineLabel();
          const report = loader.loadPipeline($canvas, pipeline);
          // TODO Use loading report!
          report.then((reportMessage) => {
            console.log("Loading report:", reportMessage);
          });
        })
        .catch((error) => {
          $status.error("Can't load pipeline", error);
        })
        .then(() => console.timeEnd("Loading pipeline"))
        .then(loadExecution)
        .catch((error) => {
          $status.error("Can't load execution", error);
        })
    }

    function loadExecution() {
      if (!data.executionIri) {
        return;
      }
      executions.loadLocal($http, data.executionIri)
        .then((jsonld) => {
          updateExecutionFromJsonld(jsonld);
          if (!$scope.isExecutionFinished) {
            data.executionUpdate = true;
            // As the refresher remove all listeners after
            // navigation, it's fine to call it here.
            // loadExecution is called only when new execution is
            // set. So either on the first load of the page,
            // or after a navigation.
            $refresh.add("ppl-canvas", updateExecution);
          }
        });
    }

    function updateExecutionFromJsonld(jsonld) {
      actions.executionFromJsonLd(jsonld, data.executionIri);
      $scope.isExecutionFinished = actions.isExecutionFinished();
      $scope.isExecutionCancelable = actions.isExecutionCancelable();
      $scope.executionIcon =
        statusToIcon(actions.getExecutionStatus(), true);
    }

    // Replacing execution cause reload and redraw of everything.
    // TODO Do not replace execution, instead just update it.
    function updateExecution() {
      if (!data.executionUpdate) {
        return;
      }
      executions.loadLocal($http, data.executionIri)
        .then((jsonld) => {
          updateExecutionFromJsonld(jsonld);
          if ($scope.isExecutionFinished) {
            data.executionUpdate = false;
          }
        });
    }

    function updatePipelineLabel() {
      let label = actions.getPipelineLabel();
      if (label === undefined || label === "") {
        label = actions.getPipelineIri();
      }
      $scope.pipelineLabel = label;
    }

    function onClose() {
      if (data.executionIri === undefined) {
        $location.path("/pipelines").search({});
      } else {
        $location.path("/executions").search({});
      }
    }

    function onEditMode() {
      activateEditMode();
    }

    function onSave() {
      actions.savePipeline().catch(onCantSave);
    }

    function onCantSave(error) {
      $status.error("Can't save pipeline.", error);
    }

    function onDelete() {
      const dialog = $dialogs.deleteConfirmationDialog();
      $mdDialog.show(dialog).then(() => {
        pipelines.deletePipeline($http, actions.getPipelineIri())
          .then(onClose)
          .catch((error) => {
            $status.error("Can't delete the pipeline.", error);
          })
      });
    }

    function onPipelineDetail() {
      const definition = actions.getPipelineResource();
      const profile = actions.getExecutionProfile();
      $dialogs.onPipelineDetail(definition, profile)
        .then(updatePipelineLabel);
    }

    function onBackupDownload() {
      $canvas.synchronize();
      const pipeline = actions.asJsonLd();
      saveAs(createPipelineBlob(pipeline),
        $scope.pipelineLabel + ".jsonld");
    }

    function createPipelineBlob(json) {
      const data = JSON.stringify(json, null, 2);
      return new Blob([data], {"type": "text/json"})
    }

    function onDownload() {
      const url = "./api/v1/pipelines?" +
        "templates=true&mappings=true&removePrivateConfig=false&iri=" +
        encodeURIComponent(actions.getPipelineIri());
      const request = {
        "headers": {
          "Accept": "application/ld+json",
        },
      };
      actions.savePipeline().then(() => {
        $http.get(url, request).then((response) => {
          saveAs(createPipelineBlob(response.data),
            $scope.pipelineLabel + ".jsonld");
        });
      });
    }

    function onDownloadNoCredentials() {
      const url = "./api/v1/pipelines?" +
        "templates=true&mappings=true&removePrivateConfig=true&iri=" +
        encodeURIComponent(actions.getPipelineIri());
      const request = {
        "headers": {
          "Accept": "application/ld+json",
        },
      };
      actions.savePipeline().then(() => {
        $http.get(url, request).then((response) => {
          saveAs(createPipelineBlob(response.data),
            $scope.pipelineLabel + ".jsonld");
        });
      });
    }

    function onCopyPipeline() {
      $canvas.synchronize();
      const pipeline = actions.asJsonLd();
      const label = "Copy of " + $scope.pipelineLabel;
      pipelines.createPipelineFromData(
        $http, actions.getPipelineIri(), pipeline, label
      ).then((iri) => {
        $status.success("Pipeline has been successfully copied.");
        $location.path("/pipelines/edit/canvas")
          .search({"pipeline": iri});
      }).catch((error) => {
        $status.error("Can't create new pipeline.", error)
      });
    }

    function onCantExecute(error) {
      $status.error("Can't start the execution.", error);
    }

    function onExecute() {
      actions.savePipeline().then(() => {
        $scope.hasExecution = true;
        actions.executePipeline({
          "keepDebugData": true
        }).catch(onCantExecute);
      }).catch(onCantSave);
    }

    function onExecuteWithoutDebugData() {
      actions.savePipeline().then(() => {
        $scope.hasExecution = true;
        actions.executePipeline({
          "keepDebugData": false
        }).catch(onCantExecute);
      }).catch(onCantSave);
    }

    function onDownloadNoSave() {
      const url = "./api/v1/pipelines?" +
        "templates=true&mappings=true&removePrivateConfig=false&iri=" +
        encodeURIComponent(actions.getPipelineIri());
      const request = {
        "headers": {
          "Accept": "application/ld+json",
        },
      };
      $http.get(url, request).then((response) => {
        saveAs(createPipelineBlob(response.data),
          $scope.pipelineLabel + ".jsonld");
      });
    }

    function onDownloadNoCredentialsNoSave() {
      const url = "./api/v1/pipelines?" +
        "templates=true&mappings=true&removePrivateConfig=true&iri=" +
        encodeURIComponent(actions.getPipelineIri());
      const request = {
        "headers": {
          "Accept": "application/ld+json",
        },
      };
      $http.get(url, request).then((response) => {
        saveAs(createPipelineBlob(response.data),
          $scope.pipelineLabel + ".jsonld");
      });
    }

    /**
     * Copy pipeline from server, throw away local changes.
     * Designed to be called from execution mode, where no changes
     * can be made.
     */
    function onCopyPipelineNoSave() {
      pipelines.copy($http, {
        "iri": data.pipelineIri,
        "label":  $scope.pipelineLabel
      })
        .then(onCopyPipelineSuccess)
        .catch(() => {
          $status.error("Can't create new pipeline.", error)
        });
    }

    function onCopyPipelineSuccess(response) {
      const jsonld = response.data;
      let iri = null;
      for (const item of jsonld) {
        if (!item["@type"]?.includes("http://linkedpipes.com/ontology/Pipeline")) {
          continue;
        }
        iri = item[ "http://etl.linkedpipes.com/ontology/localResource"][0]["@id"];
        break;
      }
      if (iri === null) {
        $status.error("Can't read pipeline IRI from response.");
        return;
      }
      $status.success("Pipeline has been successfully copied.");
      $location.path("/pipelines/edit/canvas")
        .search({"pipeline": iri});
    }

    function onCancel() {
      actions.cancelExecution(data.executionIri)
        .then((executionDeleted) => {
          if (executionDeleted) {
            // Execution no longer exists, so we leave the execution edit mode.
            $location.path("/pipelines/edit/canvas")
              .search({"pipeline": data.pipelineIri});
          } else {
            // This is just to hide the button for now,
            // the value will be updated by pipeline-actions on next
            // execution update list.
            $scope.isExecutionCancelable = false;
          }
        })
        .catch((error) => {
          $status.error("Can't cancel execution.", error);
        });
    }

    function onExecutionMode() {
      activateExecutionMode();
    }

    function onOpenLogTail() {
      const useFullScreen = ($mdMedia("sm") || $mdMedia("xs"));
      $mdDialog.show({
        "controller": "execution.log-tail.dialog",
        "template": require("./../../execution/log-tail/execution-log-tail-dialog.html"),
        "clickOutsideToClose": false,
        "fullscreen": useFullScreen,
        "locals": {
          "execution": {
            "iri": data["executionIri"],
            "label": $scope.pipelineLabel,
            "status-monitor": actions.getExecutionStatus(),
          }
        }
      });
    }

    function onChangeVisual(visualName) {
      actions.updateVisual(visualName);
      $scope.activeVisual = visualName;
    }

    return {
      "initialize": initialize,
      "onHtmlReady": onHtmlReady,
      "onClose": onClose,
      "onEditMode": onEditMode,
      "onSave": onSave,
      "onDelete": onDelete,
      "onPipelineDetail": onPipelineDetail,
      "onBackupDownload": onBackupDownload,
      "onDownload": onDownload,
      "onDownloadNoCredentials": onDownloadNoCredentials,
      "onCopyPipeline": onCopyPipeline,
      "onExecute": onExecute,
      "onExecuteWithoutDebugData": onExecuteWithoutDebugData,
      "onDisableAllLoaders": actions.onDisableAllLoaders,
      "onEnableAllLoaders": actions.onEnableAllLoaders,
      "onDownloadNoSave": onDownloadNoSave,
      "onDownloadNoCredentialsNoSave": onDownloadNoCredentialsNoSave,
      "onCopyNoSave": onCopyPipelineNoSave,
      "onCancel": onCancel,
      "onExecutionMode": onExecutionMode,
      "onOpenLogTail": onOpenLogTail,
      "onChangeVisual": onChangeVisual,
    };
  }

  factory.$inject = [
    "$location", "$http", "$mdDialog", "$mdMedia",
    "app-layout.service",
    "template.service",
    "status",
    "refresh",
    "canvas.service",
    "canvas.edit-mode.service",
    "canvas.execution-mode.service",
    "components.pipeline.canvas.dialogs"
  ];

  let initialized = false;
  return function init(app) {
    if (initialized) {
      return;
    }
    initialized = true;
    _canvasService(app);
    _editModeService(app);
    _executionModeService(app);
    _templateSelectDialog(app);
    _pipelineDetailDialog(app);
    _componentDetailDialog(app);
    _pipelineImportDialog(app);
    _templateDialog(app);
    _dialogService(app);
    _logTailDialog(app);
    app.factory("components.pipeline.canvas.service", factory);
  }

})
